import { StudentViewTranslation } from 'locales/de/pages/AWPM-FWPM/studentView';

const en: StudentViewTranslation = {
  noItems: 'There is currently no selection in your program.',
  tabs: {
    selectionInformation: 'Selection information',
    selectionInformationMobile: 'Overview',
    receivedModules: 'Received modules',
    receivedModulesMobile: 'Received',
    waitingList: 'Waiting list'
  },
  mySelection: 'My selection',
  numberOfModulesToSelect: 'How many subjects do you want to take?',
  myModules: 'My modules',
  selectableModules: 'Selectable modules',
  wishlist: 'My wish list',
  modulePrio: 'Please specify modules in descending order of priority.',
  infoBoxModuleSelection: 'Please note that this is NOT a subject ADDITION, but your WISH LIST.',
  infoBoxModuleSelectionAWPM:
    'At the end of the election you will receive an email which subjects have been assigned to you from your wish list.',
  signOut: 'Sign out',
  numberOfParticipants: 'Number of participants',
  positionInWaitingList: 'Position in waiting list',
  signOutDialogTitle: 'Sign out from module?',
  signOutDialog: 'Do you really want to unsubscribe from the module?',
  signInDialog: 'Do you really want to enroll in this module?',
  note: 'Notice',
  howManyModules: 'How many modules do you want to subscribe to?',
  alerts: {
    wishlistSaveSuccess:
      'Wishlist successfully saved. You can adjust it anytime while the selection is not over',
    wishlistSaveFailed: 'Wishlist could not be saved',
    signOutSuccess: 'You have been successfully removed from the module',
    signOutFailed: 'An error occurred while logging out of the module'
  }
};

export default en;
